// #region imports
import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
// #endregion

const MuiDialogContent = {
  styleOverrides: {
    root: ({ theme }: { theme: Theme}) => ({
      fontSize: 13,
      lineHeight: 1.2,
      flexGrow: 1,
      flex: '1 0 auto',
      padding: '0 35px 25px',
      display: 'flex',
      flexDirection: 'column',
      color: theme.palette.text.secondary,
      [theme.breakpoints.up('md')]: {
        fontSize: 20,
        padding: '0 35px 24px'
      }
    })
  }
} as Components['MuiDialogContent'];

export default MuiDialogContent;
